import './App.css';
import React, {useEffect} from 'react';
import { useCriiptoVerify } from '@criipto/verify-react';
import { useCookies } from 'react-cookie';

function Redirect() {
  const {result} = useCriiptoVerify();
  const [cookies] = useCookies(['callbackURI']);

  useEffect(() => {
    if(result?.id_token) {
        window.location.href = cookies.callbackURI + '?code=' + result?.id_token;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [result?.id_token])

    // Avbruten eller misslyckad BankID-signering (t.ex. ?error=server_error&error_description=Collect failed: startFailed).
    // Utan detta visades bara "Klar", som skickade ?code=undefined vidare.
    // Callback-cookien ligger kvar, så "/" startar om samma signering.
    if (result instanceof Error) {
        return (
            <div className='container column'>
              <p className='message'>Signeringen med BankID avbröts eller kunde inte startas.</p>
              <button className='button' onClick={() => (window.location.href = '/')}>Försök igen</button>
            </div>
        )
    }

    return (
        <div className='container'>
          <button className='button' onClick={() => (window.location.href = cookies.callbackURI + '?code=' + result?.id_token)}>Klar</button>
        </div>
    )
}

export default Redirect;
